import { render } from "./chevron-left-icon.svg?vue&type=template&id=a06c242c"
import script from "./chevron-left-icon.svg?vue&type=script&lang=js"
export * from "./chevron-left-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1567/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__